<button mat-button (click)="clickControl($event);" class="btn">
    <ng-content></ng-content>
</button>